import { render } from "./SalesReturnForm.vue?vue&type=template&id=735b4940&scoped=true&ts=true"
import script from "./SalesReturnForm.vue?vue&type=script&lang=ts"
export * from "./SalesReturnForm.vue?vue&type=script&lang=ts"

import "./SalesReturnForm.vue?vue&type=style&index=0&id=735b4940&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735b4940"]])

export default __exports__